import React, { Component, PropTypes } from "react"

class ListStudents extends Component {
  render() {
    const { students } = this.props

    return (
      <table className="table table-bordered table-condensed">
        <thead>
          <tr>
            <th width="5%" className="text-right">
              #
            </th>
            <th width="10%">ID NO.</th>
            <th>NAME OF STUDENT</th>
            <th width="10%" className="text-right">
              MID TERM
            </th>
            <th width="10%" className="text-right">
              FINAL TERM
            </th>
            <th width="10%" className="text-right">
              FINAL GRADE
            </th>
            <th width="10%" className="text-right">
              RE-EXAM
            </th>
            <th width="9%">REMARKS</th>
          </tr>
        </thead>
        <tbody>
          {students.map((student, i) => (
            <tr key={student.get("id")}>
              <td className="text-right">{i + 1}.</td>
              <td>{student.get("id")}</td>
              <td>{student.get("student_name")}</td>
              <td className="text-right">{student.get("mt")}</td>
              <td className="text-right">{student.get("ft")}</td>
              <td className="text-right">{student.get("fg")}</td>
              <td className="text-right">{student.get("re")}</td>
              <td>{student.get("re_failed") && "Failed"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

ListStudents.propTypes = {
  students: PropTypes.object,
}

export default ListStudents



// WEBPACK FOOTER //
// ./src/containers/Print/GradesSubmitted/list-students.js